import GlobalStyles from '@mui/material/GlobalStyles';

export function AppGlobalStyles() {
  return (
    <GlobalStyles
      styles={{
        ':root': {
          '--intercom-padding': '3rem',
        },
        main: {
          '& > div:last-child': {
            paddingBottom: 'var(--intercom-padding)',
          },
          '& > article:last-child': {
            paddingBottom: 'var(--intercom-padding)',
          },
        },
      }}
    />
  );
}
